import React from "react";
import PropTypes from "prop-types";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { getDateFromString } from "../../../../utils/dateUtils";
import {
  getReaderDisplayName,
  getReaderId,
} from "../../../../utils/fileUtils";

function ReadingConfirmationTable({ fileData }) {
  return (
    <div>
      {fileData?.readingConfirmation && (
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>
                <strong>Leser</strong>
              </TableCell>
              <TableCell>
                <strong>Bestätigt</strong>
              </TableCell>
              <TableCell>
                <strong>Datum</strong>
              </TableCell>
              <TableCell>
                <strong>Erinnerungen</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(fileData?.readingConfirmationList || []).map((entry, index) => (
              <TableRow key={entry?._id || getReaderId(entry) || index}>
                <TableCell>{getReaderDisplayName(entry)}</TableCell>
                <TableCell>
                  {entry?.readingConfirmed ? "Ja" : "Nein"}
                </TableCell>
                <TableCell>{getDateFromString(entry?.readAt)}</TableCell>
                <TableCell>{entry?.remindingCounter}</TableCell>
              </TableRow>
            ))}
          </TableBody>
          <Typography noWrap variant="body1">
            <strong>Frist:</strong>{" "}
            {getDateFromString(fileData?.readingDueDate)}
          </Typography>
        </Table>
      )}
    </div>
  );
}

ReadingConfirmationTable.propTypes = {
  fileData: PropTypes.object,
};

export default ReadingConfirmationTable;
